/* tslint:disable */
/* eslint-disable */
/**
 * Account Settings API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { AccountDeletionTaskStatRatio } from './';
import {
    AccountDeletionTaskStatRatioFromJSON,
    AccountDeletionTaskStatRatioFromJSONTyped,
    AccountDeletionTaskStatRatioToJSON,
} from './';

/**
 * 
 * @export
 * @interface UndefinedAccountDeletionTaskStatsForPeriod
 */
export interface UndefinedAccountDeletionTaskStatsForPeriod {
    /**
     * 
     * @type {number}
     * @memberof UndefinedAccountDeletionTaskStatsForPeriod
     */
    totalTasks: number;
    /**
     * 
     * @type {number}
     * @memberof UndefinedAccountDeletionTaskStatsForPeriod
     */
    totalTasksEnded: number;
    /**
     * 
     * @type {AccountDeletionTaskStatRatio}
     * @memberof UndefinedAccountDeletionTaskStatsForPeriod
     */
    reactivatedAccounts: AccountDeletionTaskStatRatio;
    /**
     * 
     * @type {AccountDeletionTaskStatRatio}
     * @memberof UndefinedAccountDeletionTaskStatsForPeriod
     */
    reactivatedButThenDeletedAccounts: AccountDeletionTaskStatRatio;
    /**
     * 
     * @type {AccountDeletionTaskStatRatio}
     * @memberof UndefinedAccountDeletionTaskStatsForPeriod
     */
    reactivatedAccountsAfter1Email: AccountDeletionTaskStatRatio;
    /**
     * 
     * @type {AccountDeletionTaskStatRatio}
     * @memberof UndefinedAccountDeletionTaskStatsForPeriod
     */
    reactivatedAccountsAfter2Emails: AccountDeletionTaskStatRatio;
    /**
     * 
     * @type {AccountDeletionTaskStatRatio}
     * @memberof UndefinedAccountDeletionTaskStatsForPeriod
     */
    deletedAccounts: AccountDeletionTaskStatRatio;
    /**
     * 
     * @type {AccountDeletionTaskStatRatio}
     * @memberof UndefinedAccountDeletionTaskStatsForPeriod
     */
    deletedAccountsImmediately: AccountDeletionTaskStatRatio;
    /**
     * 
     * @type {AccountDeletionTaskStatRatio}
     * @memberof UndefinedAccountDeletionTaskStatsForPeriod
     */
    deletedAccountsAfterBounce: AccountDeletionTaskStatRatio;
    /**
     * 
     * @type {AccountDeletionTaskStatRatio}
     * @memberof UndefinedAccountDeletionTaskStatsForPeriod
     */
    deletedAccountsAfterFullWorkflow: AccountDeletionTaskStatRatio;
    /**
     * 
     * @type {AccountDeletionTaskStatRatio}
     * @memberof UndefinedAccountDeletionTaskStatsForPeriod
     */
    adminCancellations: AccountDeletionTaskStatRatio;
    /**
     * 
     * @type {AccountDeletionTaskStatRatio}
     * @memberof UndefinedAccountDeletionTaskStatsForPeriod
     */
    deletionsNotPossible: AccountDeletionTaskStatRatio;
}

/**
 * Check if a given object implements the UndefinedAccountDeletionTaskStatsForPeriod interface.
 */
export function instanceOfUndefinedAccountDeletionTaskStatsForPeriod(value: object): value is UndefinedAccountDeletionTaskStatsForPeriod {
    if (!('totalTasks' in value) || value['totalTasks'] === undefined) return false;
    if (!('totalTasksEnded' in value) || value['totalTasksEnded'] === undefined) return false;
    if (!('reactivatedAccounts' in value) || value['reactivatedAccounts'] === undefined) return false;
    if (!('reactivatedButThenDeletedAccounts' in value) || value['reactivatedButThenDeletedAccounts'] === undefined) return false;
    if (!('reactivatedAccountsAfter1Email' in value) || value['reactivatedAccountsAfter1Email'] === undefined) return false;
    if (!('reactivatedAccountsAfter2Emails' in value) || value['reactivatedAccountsAfter2Emails'] === undefined) return false;
    if (!('deletedAccounts' in value) || value['deletedAccounts'] === undefined) return false;
    if (!('deletedAccountsImmediately' in value) || value['deletedAccountsImmediately'] === undefined) return false;
    if (!('deletedAccountsAfterBounce' in value) || value['deletedAccountsAfterBounce'] === undefined) return false;
    if (!('deletedAccountsAfterFullWorkflow' in value) || value['deletedAccountsAfterFullWorkflow'] === undefined) return false;
    if (!('adminCancellations' in value) || value['adminCancellations'] === undefined) return false;
    if (!('deletionsNotPossible' in value) || value['deletionsNotPossible'] === undefined) return false;
    return true;
}

export function UndefinedAccountDeletionTaskStatsForPeriodFromJSON(json: any): UndefinedAccountDeletionTaskStatsForPeriod {
    return UndefinedAccountDeletionTaskStatsForPeriodFromJSONTyped(json, false);
}

export function UndefinedAccountDeletionTaskStatsForPeriodFromJSONTyped(json: any, ignoreDiscriminator: boolean): UndefinedAccountDeletionTaskStatsForPeriod {
    if (json == null) {
        return json;
    }
    return {
        
        'totalTasks': json['totalTasks'],
        'totalTasksEnded': json['totalTasksEnded'],
        'reactivatedAccounts': AccountDeletionTaskStatRatioFromJSON(json['reactivatedAccounts']),
        'reactivatedButThenDeletedAccounts': AccountDeletionTaskStatRatioFromJSON(json['reactivatedButThenDeletedAccounts']),
        'reactivatedAccountsAfter1Email': AccountDeletionTaskStatRatioFromJSON(json['reactivatedAccountsAfter1Email']),
        'reactivatedAccountsAfter2Emails': AccountDeletionTaskStatRatioFromJSON(json['reactivatedAccountsAfter2Emails']),
        'deletedAccounts': AccountDeletionTaskStatRatioFromJSON(json['deletedAccounts']),
        'deletedAccountsImmediately': AccountDeletionTaskStatRatioFromJSON(json['deletedAccountsImmediately']),
        'deletedAccountsAfterBounce': AccountDeletionTaskStatRatioFromJSON(json['deletedAccountsAfterBounce']),
        'deletedAccountsAfterFullWorkflow': AccountDeletionTaskStatRatioFromJSON(json['deletedAccountsAfterFullWorkflow']),
        'adminCancellations': AccountDeletionTaskStatRatioFromJSON(json['adminCancellations']),
        'deletionsNotPossible': AccountDeletionTaskStatRatioFromJSON(json['deletionsNotPossible']),
    };
}

export function UndefinedAccountDeletionTaskStatsForPeriodToJSON(value?: UndefinedAccountDeletionTaskStatsForPeriod | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'totalTasks': value['totalTasks'],
        'totalTasksEnded': value['totalTasksEnded'],
        'reactivatedAccounts': AccountDeletionTaskStatRatioToJSON(value['reactivatedAccounts']),
        'reactivatedButThenDeletedAccounts': AccountDeletionTaskStatRatioToJSON(value['reactivatedButThenDeletedAccounts']),
        'reactivatedAccountsAfter1Email': AccountDeletionTaskStatRatioToJSON(value['reactivatedAccountsAfter1Email']),
        'reactivatedAccountsAfter2Emails': AccountDeletionTaskStatRatioToJSON(value['reactivatedAccountsAfter2Emails']),
        'deletedAccounts': AccountDeletionTaskStatRatioToJSON(value['deletedAccounts']),
        'deletedAccountsImmediately': AccountDeletionTaskStatRatioToJSON(value['deletedAccountsImmediately']),
        'deletedAccountsAfterBounce': AccountDeletionTaskStatRatioToJSON(value['deletedAccountsAfterBounce']),
        'deletedAccountsAfterFullWorkflow': AccountDeletionTaskStatRatioToJSON(value['deletedAccountsAfterFullWorkflow']),
        'adminCancellations': AccountDeletionTaskStatRatioToJSON(value['adminCancellations']),
        'deletionsNotPossible': AccountDeletionTaskStatRatioToJSON(value['deletionsNotPossible']),
    };
}

